/** Classement d'un défi live privé (invités compris, prénom affiché). */

import { cn } from '@jeraisonne/ui';
import type { PrivateBoard } from '@/lib/private-live';
import { MyPositionCard, RankingList, type RankingRow } from '@/features/live-ui/ranking-list';

/** Lignes du classement d'un défi privé. PUR. */
export function privateRankingRows(board: PrivateBoard): RankingRow[] {
  return board.rows.map((r, i) => ({
    key: `${r.rank}-${r.name}-${i}`,
    rank: r.rank,
    name: r.name,
    avatarUrl: r.avatar_url,
    score: r.total_score,
    isMe: r.is_me,
    tag: r.is_guest ? 'Invité' : null,
  }));
}

export function PrivateLeaderboard({
  board,
  unit,
  paper = false,
}: {
  board: PrivateBoard | undefined;
  unit: string;
  /** Feuille claire posée sur l'écran sombre d'un live. */
  paper?: boolean;
}) {
  const empty = cn('text-sm', paper ? 'text-ink-600 text-center' : 'text-ink-500');
  if (!board) return <p className={empty}>Chargement du classement…</p>;
  if (board.rows.length === 0) return <p className={empty}>Personne n’est encore classé.</p>;
  const rows = privateRankingRows(board);
  const meVisible = rows.some((r) => r.isMe);
  return (
    <div className="space-y-3">
      <RankingList rows={rows} unit={unit} paper={paper} />
      {board.me && !meVisible && (
        <MyPositionCard
          rank={board.me.rank}
          total={board.me.total}
          className={paper ? 'theme-paper' : undefined}
        />
      )}
    </div>
  );
}
